document.addEventListener('DOMContentLoaded', () => {
    const $searchForms = document.querySelectorAll('form[data-suggest]');

    // Search Autosuggest - Helper functions
    const escapeHtml = (text) => {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    };

    const escapeRegex = (text) => text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

    // Initialize autosuggest for each form with data-suggest
    $searchForms.forEach(($form) => {
        const $input = $form.querySelector('.tx-solr-suggest');
        const $container = $form.querySelector('.tx-solr-autocomplete');

        if (!$input || !$container) return;
        let debounceTimer;

        const selectSuggestion = (suggestion) => {
            $input.value = suggestion;

            const $expandPanel = $container.parentElement;
            if ($expandPanel) {
                $expandPanel.classList.remove('autocomplete-active');
                $expandPanel.style.pointerEvents = 'none';
            }
            const $submitButton = $form.querySelector('button[type="submit"]');
            if ($submitButton) {
                $submitButton.click();
            }
        };

        const renderSuggestions = (data, query) => {
            let html = '<div class="autocomplete-suggestions tx-solr-autosuggest">';

            if (data.suggestions && Object.keys(data.suggestions).length > 0) {
                Object.entries(data.suggestions).forEach(([suggestion]) => {
                    const highlighted = suggestion.replace(
                        new RegExp(`(${escapeRegex(query.trim())})`, 'gi'),
                        '<strong>$1</strong>',
                    );
                    html += `<div class="autocomplete-suggestion suggestion" data-suggestion="${escapeHtml(suggestion)}">${highlighted}</div>`;
                });
            } else {
                $container.innerHTML = '';
                const $expandPanel = $container.parentElement;
                if ($expandPanel) {
                    $expandPanel.classList.remove('autocomplete-active');
                    $expandPanel.style.pointerEvents = 'none';
                }
                return;
            }

            html += '</div>';

            $container.innerHTML = html;

            $container.parentElement.classList.add('autocomplete-active');

            // Make the search panel visible if it exists (for header search)
            const $searchPanel = $form.closest('.search-wrapper-panel');
            if ($searchPanel) {
                $searchPanel.classList.add('open');
            }

            const $suggestions = $container.querySelectorAll('.autocomplete-suggestion');
            $suggestions.forEach(($suggestion) => {
                $suggestion.addEventListener('click', (e) => {
                    e.stopPropagation();
                    selectSuggestion($suggestion.dataset?.suggestion);
                });
            });
        };

        const fetchSuggestions = async (query) => {
            if (!query || query.trim().length < 3) {
                $container.innerHTML = '';
                return;
            }

            const suggestUrl = $form.dataset.suggest;
            const url = new URL(suggestUrl, window.location.origin);
            url.searchParams.set('tx_solr[queryString]', query);

            try {
                const response = await fetch(url.toString());
                const data = await response.json();
                renderSuggestions(data, query);
            // eslint-disable-next-line no-unused-vars
            } catch (error) {
                // Silent fail for network errors
            }
        };

        $input.addEventListener('input', (e) => {
            clearTimeout(debounceTimer);
            const query = e.target.value;
            debounceTimer = setTimeout(() => {
                fetchSuggestions(query);
            }, 300);
        });
    });
});
